import React from 'react';
import './HowWeThink.css';

function HowWeThink() {
  const philosophies = [
    'Health is not one-size-fits-all',
    'Simplicity beats complexity',
    'Long-term impact matters more than short-term hype',
    'Technology should support humans, not replace them',
    'Integrity over growth-at-all-costs'
  ];

  return (
    <section id="how-we-think" className="how-we-think-section">
      <div className="container">
        <h2 className="section-title">Our Philosophy</h2>
        <div className="philosophies-list">
          {philosophies.map((philosophy, index) => (
            <div key={index} className="philosophy-item">
              <div className="philosophy-bullet">✓</div>
              <p className="philosophy-text">{philosophy}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowWeThink;
